import React from 'react';
import { Button, Table, ButtonGroup } from '../common';
import CloudAccount from '../../models/CloudAccount';
import moment from 'moment';
import './ApprovalsAccountsTableRow.css';
import { authenticatedUser } from '../../authentication/authModule';
import { UserRole } from '../../models/enums/UserRole';

interface ApprovalsAccountsTableRowProps {
    account: CloudAccount;
    setApproveModalVisible: Function;
    setSelectedCloudAccount: Function;
    setRejectModalVisible: Function;
    setReasonModalVisible: Function;
}

const ApprovalsAccountsTableRow = ({ account, setApproveModalVisible, setSelectedCloudAccount, setRejectModalVisible, setReasonModalVisible }: ApprovalsAccountsTableRowProps) => {
    const date = new Date(account.workflowInstance.createdDate);
    return (
        <Table.Row key={account.id}>
            <Table.Cell>{account.createdUserPrincipalName}</Table.Cell>
            <Table.Cell className='em-u-text-align-center'>{moment(date).format('MM/DD/YYYY')}</Table.Cell>
            <Table.Cell className='center-align'>
                <ButtonGroup optionalClass='em-u-text-align-center center-align'>
                    <Button
                        variant="primary"
                        disabled={(authenticatedUser.isInRole(UserRole.ApprovalsViewer) && (account.approver !== authenticatedUser.userEmail))}
                        onClick={() => {
                            setApproveModalVisible(true);
                            setSelectedCloudAccount(account);
                        }}
                    >Approve
                    </Button>
                    <Button
                        variant="secondary"
                        disabled={(authenticatedUser.isInRole(UserRole.ApprovalsViewer) && (account.approver !== authenticatedUser.userEmail))}
                        onClick={() => {
                            setRejectModalVisible(true);
                            setSelectedCloudAccount(account);
                        }}
                    >Reject
                    </Button>
                    <Button
                        variant="primary"
                        onClick={() => {
                            setReasonModalVisible(true);
                            setSelectedCloudAccount(account);
                        }}
                    >View Request
                    </Button>
                </ButtonGroup>
            </Table.Cell>
        </Table.Row>
    );
}

export default ApprovalsAccountsTableRow;